import { render, staticRenderFns } from "./AddImageModal.vue?vue&type=template&id=4bf4c07a&scoped=true&"
import script from "./AddImageModal.vue?vue&type=script&lang=js&"
export * from "./AddImageModal.vue?vue&type=script&lang=js&"
import style0 from "./AddImageModal.vue?vue&type=style&index=0&id=4bf4c07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4c07a",
  null
  
)

export default component.exports